import { render, staticRenderFns } from "./kupon.vue?vue&type=template&id=3875bf2d&"
import script from "./kupon.vue?vue&type=script&lang=js&"
export * from "./kupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports